<ng-container *transloco="let t">
<div class="row p-4 mb-3">
  <div class="form-group mb-3 col-md-12">
    <label class="form-label" for="accountNumber">{{ t('portal.payment.accountNumber') }}</label>
    <input
      type="text"
      class="form-control"
      [(ngModel)]="paymentInfo.accountNumber"
      name="accountNumber"
      required
      #accountNumberInput="ngModel"
      [ngClass]="{
        'is-invalid':
          accountNumberInput &&
          accountNumberInput.touched &&
          accountNumberInput.invalid
      }"
    />
    <div class="invalid-feedback">{{ t('common.required') }}</div>
  </div>

  <div class="form-group mb-3 col-md-6">
    <label class="form-label" for="billingName">{{ t('portal.payment.name') }}</label>
    <input
      type="text"
      class="form-control"
      [(ngModel)]="paymentInfo.billingName"
      name="billingName"
      required
      #billingNameInput="ngModel"
      [ngClass]="{
        'is-invalid':
          billingNameInput &&
          billingNameInput.touched &&
          billingNameInput.invalid
      }"
    />
    <div class="invalid-feedback">{{ t('common.required') }}</div>
  </div>

  <div class="form-group mb-3 col-md-6">
    <label class="form-label" for="expirationDate">{{ t('portal.payment.expirationDate') }}</label>
    <input
      class="form-control"
      type="month"
      id="expirationDate"
      name="expirationDate"
      [ngModel]="expirationDate | date : 'yyyy-MM'"
      (ngModelChange)="expirationDateChanged($event)"
    />
  </div>

  <div class="form-group mb-3 col-md-6">
    <label class="form-label" for="billingAddress">{{ t('portal.payment.billingAddress') }}</label>
    <input
      type="text"
      class="form-control"
      [(ngModel)]="paymentInfo.billingAddress"
      name="billingAddress"
      required
      #billingAddressInput="ngModel"
      [ngClass]="{
        'is-invalid':
          billingAddressInput &&
          billingAddressInput.touched &&
          billingAddressInput.invalid
      }"
    />
    <div class="invalid-feedback">{{ t('common.required') }}</div>
  </div>

  <div class="form-group mb-3 col-md-6">
    <label class="form-label" for="billingAddress">{{ t('portal.payment.billingAddress2') }}</label>
    <input
      type="text"
      class="form-control"
      [(ngModel)]="paymentInfo.billingAddress2"
      name="billingAddress"
    />
  </div>

  <div class="form-group mb-3 col-md-4">
    <label class="form-label" for="billingState">{{ t('portal.payment.state') }}</label>
    <select
      class="form-select"
      [(ngModel)]="paymentInfo.billingState"
      name="billingState"
      required
      #billingStateInput="ngModel"
      [ngClass]="{
        'is-invalid':
          billingStateInput &&
          billingStateInput.touched &&
          billingStateInput.invalid
      }"
    >
      @for (s of states; track s.value) {
        <option [ngValue]="s.value">{{ s.name }}</option>
      }
    </select>
    <div class="invalid-feedback">{{ t('common.required') }}</div>
  </div>

  <div class="form-group mb-3 col-md-4">
    <label class="form-label" for="billingCity">{{ t('portal.payment.city') }}</label>
    <input
      type="text"
      class="form-control"
      [(ngModel)]="paymentInfo.billingCity"
      name="billingCity"
      required
      #billingCityInput="ngModel"
      [ngClass]="{
        'is-invalid':
          billingCityInput &&
          billingCityInput.touched &&
          billingCityInput.invalid
      }"
    />
    <div class="invalid-feedback">{{ t('common.required') }}</div>
  </div>

  <div class="form-group mb-3 col-md-4">
    <label class="form-label" for="billingZip">{{ t('portal.payment.zipCode') }}</label>
    <input
      type="text"
      class="form-control"
      [(ngModel)]="paymentInfo.billingZip"
      name="billingZip"
      mask="00000"
      placeHolderCharacter="X"
      [showMaskTyped]="true"
      required
      #billingZipInput="ngModel"
      [ngClass]="{
        'is-invalid':
          billingZipInput && billingZipInput.touched && billingZipInput.invalid
      }"
    />
    <div class="invalid-feedback">{{ t('common.required') }}</div>
  </div>

  <div class="form-group mb-3 col-md-6">
    <label class="form-label" for="billingPhoneNumber">{{ t('portal.payment.phoneNumber') }}</label>
    <input
      type="tel"
      class="form-control"
      [(ngModel)]="paymentInfo.billingPhoneNumber"
      name="billingPhoneNumber"
      mask="(000) 000-0000"
      placeHolderCharacter="X"
      [showMaskTyped]="true"
      required
      #billingPhoneNumberInput="ngModel"
      [ngClass]="{
        'is-invalid':
          billingPhoneNumberInput &&
          billingPhoneNumberInput.touched &&
          billingPhoneNumberInput.invalid
      }"
    />
    <div class="invalid-feedback">{{ t('common.required') }}</div>
  </div>
  <div class="form-group mb-3 col-md-6">
    <label class="form-label" for="billingEmail">{{ t('portal.payment.emailAddress') }}</label>
    <input
      type="email"
      class="form-control"
      [(ngModel)]="paymentInfo.billingEmail"
      name="billingEmail"
      required
      pattern="[a-zA-Z0-9.-_]{1,}@[a-zA-Z.-]{2,}[.]{1}[a-zA-Z]{2,}"
      #billingEmailInput="ngModel"
      [ngClass]="{
        'is-invalid':
          billingEmailInput &&
          billingEmailInput.touched &&
          billingEmailInput.invalid
      }"
    />
    @if (billingEmailInput.errors?.required && billingEmailInput.touched) {
      <div class="invalid-feedback d-block">{{ t('common.required') }}</div>
    }
    @if (billingEmailInput.errors?.pattern) {
      <div
        class="invalid-feedback d-block"
      >
        {{ t('portal.payment.invalidEmailFormat') }}
      </div>
    }
  </div>
</div>
</ng-container>
